import React from 'react'
import Section from '../_common/Section'

export default () => {
  return (
    <Section
      title="物件検索"
      category="properties"
      mainID="property_id"
      labels={[
        {
          id: 'bits_property_id',
          name: 'BITS物件ID'
        },
        {
          id: 'property_name',
          name: '物件名'
        },
        {
          id: 'room_count',
          name: '戸数'
        },
        {
          id: 'registered_users',
          name: 'アプリ利用者数'
        },
        {
          id: 'created_date',
          name: '作成日'
        },
        {
          id: 'csv_url',
          name: 'CSVダウンロード'
        },
        {
          id: 'push',
          name: 'プッシュ通知'
        },
        {
          id: 'chat',
          name: 'チャット'
        }
      ]}
      // labels={['ID', '物件名', '電話番号', '住所', 'メールアドレス', '作成日']}
      // labelsID={[ 'property_id', 'name', 'tel', 'place', 'email', 'created' ]}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/Properties/index.js